import { lazy } from "react";
import { clearStudioView, setStudioView } from "../workspace/studio-views";
import type { PhotoSessionProps } from "./PhotoSession";
const PhotoSession = lazy(() => import("./PhotoSession").then((module) => ({ default: module.PhotoSession })));

/** Sing with your photo on the storyboard step; any other production clears the slot. */
export function mountPhotoSession(projectId: string, props: PhotoSessionProps | null) {
  if (!props) return clearStudioView("photo-session");
  setStudioView("photo-session", `photo-session:${projectId}`, <PhotoSession {...props} />);
}
